import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { Stack, Typography } from "@mui/material";
import MobileStores from "../../../../global/MobileStores/MobileStores";

export const ListingModalStandalone = () => {
  const theme = useSelector((state: RootState) => state.theme);
  return (
    <Stack className="flex flex-col items-center justify-center space-y-[14px] px-[20px] py-[32px]">
      <Typography
        sx={{
          color: theme.componentColors.surface.onSurface,
        }}
        className="text-2xl font-normal text-center "
        variant="h2"
      >
        This is a Free Workout!
      </Typography>

      <Typography className="text-lg font-light text-center" variant="body1">
        Access this workout, plus much more, on the{" "}
        <span
          style={{
            color: theme.componentColors.primary.primary,
          }}
          className="font-semibold"
        >
          Pod1um
        </span>{" "}
        mobile App. <br />
        Available on both iOS & Android.
      </Typography>
      <Stack className="flex flex-col items-center justify-center space-y-[14px]">
        <Typography className="text-2xl font-normal text-center ">
          Get the App
        </Typography>
        <MobileStores />
      </Stack>
    </Stack>
  );
};
